// Yearly US market history, 1928 to 2025, for the historical test of a plan.
// Stocks: S&P 500 total return. Bonds: 10-year US Treasury total return. Both
// from Aswath Damodaran's published annual returns (NYU Stern). Inflation: the
// change in the annual average CPI-U (US Bureau of Labor Statistics, as
// tabulated by the Federal Reserve Bank of Minneapolis). All in percent.
// Generated from those tables; do not edit by hand.
export const HISTORY_FIRST_YEAR = 1928;

// [stocks, bonds, inflation]
export const HISTORICAL_RETURNS = [
  [43.81, 0.84, -1.15], // 1928
  [-8.30, 4.20, 0.00], // 1929
  [-25.12, 4.54, -2.91], // 1930
  [-43.84, -2.56, -8.98], // 1931
  [-8.64, 8.79, -10.53], // 1932
  [49.98, 1.86, -5.15], // 1933
  [-1.19, 7.96, 3.88], // 1934
  [46.74, 4.47, 2.24], // 1935
  [31.94, 5.02, 1.46], // 1936
  [-35.34, 1.38, 3.60], // 1937
  [29.28, 4.21, -2.08], // 1938
  [-1.10, 4.41, -1.42], // 1939
  [-10.67, 5.40, 0.72], // 1940
  [-12.77, -2.02, 5.00], // 1941
  [19.17, 2.29, 10.88], // 1942
  [25.06, 2.49, 6.13], // 1943
  [19.03, 2.58, 1.73], // 1944
  [35.82, 3.80, 2.27], // 1945
  [-8.43, 3.13, 8.33], // 1946
  [5.20, 0.92, 14.36], // 1947
  [5.70, 1.95, 7.62], // 1948
  [18.30, 4.66, -0.83], // 1949
  [30.81, 0.43, 1.26], // 1950
  [23.68, -0.30, 7.88], // 1951
  [18.15, 2.27, 2.31], // 1952
  [-1.21, 4.14, 0.75], // 1953
  [52.56, 3.29, 0.37], // 1954
  [32.60, -1.34, -0.37], // 1955
  [7.44, -2.26, 1.49], // 1956
  [-10.46, 6.80, 3.31], // 1957
  [43.72, -2.10, 2.85], // 1958
  [12.06, -2.65, 1.04], // 1959
  [0.34, 11.64, 1.37], // 1960
  [26.64, 2.06, 1.01], // 1961
  [-8.81, 5.69, 1.34], // 1962
  [22.61, 1.68, 0.99], // 1963
  [16.42, 3.73, 1.31], // 1964
  [12.40, 0.72, 1.61], // 1965
  [-9.97, 2.91, 3.17], // 1966
  [23.80, -1.58, 2.77], // 1967
  [10.81, 3.27, 4.19], // 1968
  [-8.24, -5.01, 5.46], // 1969
  [3.56, 16.75, 5.72], // 1970
  [14.22, 9.79, 4.38], // 1971
  [18.76, 2.82, 3.21], // 1972
  [-14.31, 3.66, 6.22], // 1973
  [-25.90, 1.99, 11.04], // 1974
  [37.00, 3.61, 9.13], // 1975
  [23.83, 15.98, 5.76], // 1976
  [-6.98, 1.29, 6.50], // 1977
  [6.51, -0.78, 7.59], // 1978
  [18.52, 0.67, 11.35], // 1979
  [31.74, -2.99, 13.50], // 1980
  [-4.70, 8.20, 10.32], // 1981
  [20.42, 32.81, 6.16], // 1982
  [22.34, 3.20, 3.21], // 1983
  [6.15, 13.73, 4.32], // 1984
  [31.24, 25.71, 3.56], // 1985
  [18.49, 24.28, 1.86], // 1986
  [5.81, -4.96, 3.65], // 1987
  [16.54, 8.22, 4.14], // 1988
  [31.48, 17.69, 4.82], // 1989
  [-3.06, 6.24, 5.40], // 1990
  [30.23, 15.00, 4.21], // 1991
  [7.49, 9.36, 3.01], // 1992
  [9.97, 14.21, 2.99], // 1993
  [1.33, -8.04, 2.56], // 1994
  [37.20, 23.48, 2.83], // 1995
  [22.68, 1.43, 2.95], // 1996
  [33.10, 9.94, 2.29], // 1997
  [28.34, 14.92, 1.56], // 1998
  [20.89, -8.25, 2.21], // 1999
  [-9.03, 16.66, 3.36], // 2000
  [-11.85, 5.57, 2.85], // 2001
  [-21.97, 15.12, 1.58], // 2002
  [28.36, 0.38, 2.28], // 2003
  [10.74, 4.49, 2.66], // 2004
  [4.83, 2.87, 3.39], // 2005
  [15.61, 1.96, 3.23], // 2006
  [5.48, 10.21, 2.83], // 2007
  [-36.55, 20.10, 3.86], // 2008
  [25.94, -11.12, -0.37], // 2009
  [14.82, 8.46, 1.68], // 2010
  [2.10, 16.04, 3.12], // 2011
  [15.89, 2.97, 2.09], // 2012
  [32.15, -9.10, 1.48], // 2013
  [13.52, 10.75, 1.59], // 2014
  [1.38, 1.28, 0.13], // 2015
  [11.77, 0.69, 1.27], // 2016
  [21.61, 2.80, 2.12], // 2017
  [-4.23, -0.02, 2.45], // 2018
  [31.21, 9.64, 1.83], // 2019
  [18.02, 11.33, 1.21], // 2020
  [28.47, -4.42, 4.71], // 2021
  [-18.04, -17.83, 8.01], // 2022
  [26.06, 3.88, 4.10], // 2023
  [24.88, -1.64, 2.95], // 2024
  [17.78, 7.80, 2.61], // 2025
];
